import { render, staticRenderFns } from "./videoConfInfo.vue?vue&type=template&id=fa7ed8cc&scoped=true&lang=pug&"
import script from "./videoConfInfo.vue?vue&type=script&lang=js&"
export * from "./videoConfInfo.vue?vue&type=script&lang=js&"
import style0 from "./videoConfInfo.vue?vue&type=style&index=0&id=fa7ed8cc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7ed8cc",
  null
  
)

export default component.exports